import * as React from 'react';
import BEMHelper from 'react-bem-helper';

// BEM block stays 'Button' (not 'BaseButton'): Cypress selectors and CSS overrides
// depend on the `.Button` / `.Button--*` class names.
const classes = new BEMHelper('Button');

export interface BaseButtonProps
    extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
    color?: 'success' | 'link';
    outline?: boolean;
    primary?: boolean;
    block?: boolean;
}

const BaseButton: React.FC<BaseButtonProps> = ({
    children,
    color,
    outline = false,
    primary = false,
    block = false,
    className,
    ...rest
}) => (
    <button
        {...rest}
        {...classes(
            undefined,
            {
                outline,
                primary,
                block,
                success: color === 'success',
                link: color === 'link',
            },
            className
        )}
    >
        {children}
    </button>
);

export default BaseButton;
